enum FeatureFlags {
  CART_HAMS_CCP_OPEN_QUOTE_MIGRATION = 'cart-hams-ccp-open-quote-migration',
  CART_MAC_MIGRATION_ENABLE_CCP_SEARCH_CALL = 'cart-mac-migration-enable-ccp-search-call',
  MIGRATION_CLOUDS_BANNER_FOR_PARTNERS = 'migration_clouds_baner_for_partners',
  CART_MAINTENANCE_BANNER = 'cart-maintenance-banner',
  CART_LIMIT_DC_MULTI_YEAR_CONTRACTS = 'cart-limit-dc-multi-year-contracts',
  CLOUD_MIGRATION_TRIAL_LINK = 'cloud_migration_trial_cta_enabled',
  CART_EGYPT_TAX_EXEMPTIONS_FIELD = 'cart-egypt-tax-exemption-field',
  CART_CANADA_TAX_EXEMPTIONS_FIELD = 'cart-canada-tax-exemption-field',
  CART_ENABLE_VAT_FOR_SERBIA = 'sc_enable_vat_for_serbia',
  CART_DC_PRODUCT_APP_COUPLING = 'cart-dc-product-app-coupling',
  CART_MAC_CLOUD_READ_MODE = 'cart-mac-cloud-read-mode',
  CART_MAC_ADDON_HIDE_MANUAL_OPTION = 'cart-dc-product-app-coupling-hide-manual-option',
  CART_MAC_DISABLE_DC_TRIAL = 'cart-mac-disable-dc-trial',
  CART_ENABLE_OMNI_CHANNEL_CHAT = 'cart-enable-omni-channel-chat',
  CART_CD_EOS = 'cart-cd-eos',
  CART_MAPPING_PARENT_APP_CSV = 'cart_mapping-parent-app-csv',
}

export default FeatureFlags;
